import { useCallback, useContext, useEffect, useState } from "react";

import { t } from "i18next";


import { EvtsFooter } from "../../components/shared/EvtsFooter";
import { ArrowRight } from "../../components/shared/Icons/ArrowRight";
import Button from "../../components/shared/button/Button";
import EventialsHeader from "../../components/shared/EventialsHeader";
import Modal from "../../components/shared/modal/Modal";
import Typography from "../../components/shared/typography/Typography";
import { IConfig } from "../../interfaces/event/config";

import {
  Container,
  Wrapper,
  NavMenu,
  Section,
  NavMenuItem,
  Divider,
  ModalContent,
  HeaderNav,
  ButtonContainerDesktop,
  ButtonContainerMobile
} from "./style";
import colors from "../../theme/colors";
import { breakpointSize } from "../../theme/mediaQuerie";

import { API_URL, WL_URL } from "../../settings";
import { mockWL } from "./mock";
import { Panel } from "../../components/videoConference/Panel";
import { ChannelContext } from "../../context/channel";
import axios from "axios";
import { dashboardApi } from "../../api/DashboardApi";
import { notification } from "antd";

const isMobile = window.innerWidth <= breakpointSize.Sm;

const initialPanel = {
  header: {
    backgroundColor: "",
    logo: ""
  },
  body: {
    form: {
      bannerBackground: "",
      pageBackground: "",
      tagColor: ""
    },
    watch: {
      descriptionBackground: ""
    },
  },
  images: {
    logo: ""
  },
  enabled_groups: []
}

export const VideoConference = () => {

  const [dataConfig, setDataConfig] = useState(initialPanel);
  const [config, setConfig] = useState<IConfig>(mockWL.config);
  const [modalTheme, setModalTheme] = useState(false);
  const [modalExclude, setModalExclude] = useState(false);
  const [modalPublish, setModalPublish] = useState(false);
  const { data, channel } = useContext(ChannelContext)
  const [groups, setGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fillGroups();
    if (data) {
      setDataConfig({
        header: {
          backgroundColor: data?.header?.backgroundColor,
          logo: data?.header?.logo
        },
        body: {
          form: {
            bannerBackground: data?.body?.form?.bannerBackground,
            pageBackground: data?.body?.form?.pageBackground,
            tagColor: data?.body?.form?.tagColor
          },
          watch: {
            descriptionBackground: data?.body?.watch?.descriptionBackground
          }
        },
        images: {
          logo: data?.images?.logo
        },
        enabled_groups: data?.enabled_groups
      })
    }

  }, [data])

  const fillGroups = useCallback(() => {
    dashboardApi
      .listGroups(channel)
      .then((response: any) => {
        setGroups(response.groups)
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel]);


  async function onPublish() {
    setLoading(true);
    const data: any = {
      order_talks: "ASC",
      ...dataConfig,
      config: {},
      footer: {},
      logo: dataConfig.header.logo,
      about_image: {},
      enabled_groups: dataConfig?.enabled_groups?.length > 0 ? dataConfig.enabled_groups : [groups[0].id],
      images: {
        logo: dataConfig.header.logo,
        about_image: dataConfig.header.logo
      },
      kind: "video-conference"
    };

    const formData = new FormData();
    try {
      for (var key in data) {
        if (typeof data[key] === 'object' && !(data[key] instanceof Blob)) {
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      }
      await axios.post(`${API_URL}/api/whitelabel/${channel}/customization/`, formData, {
        withCredentials: true
      });
      setLoading(false)
    } catch (error) {
      setLoading(false)
      notification.error({
        message: "Tivemos algum problema ao publicar, tente novamente mais tarde.",
      });
    }

    try {
      await axios.post(`${API_URL}/api/whitelabel/${channel}/publish/`, formData, {
        withCredentials: true
      });
    } catch (error) {
      setLoading(false)
    }

    setModalPublish(false)
    notification.success({
      message: "Alterações salvas com sucesso!",
    });
    setLoading(false)

  }

  return (
    <Container>

      {/*theme modal*/}
      <Modal
        show={modalTheme}
        handleShow={setModalTheme}
        title={`${config.theme === 'dark' ? 'Light' : 'Dark'} mode`}
        description={t("dashboard.event.theme.modalText")!}
      >
        <ModalContent>
          <div>
            <Button
              variant="cancel"
              fullWidth
              size="small"
              onClick={() => setModalTheme(false)}
              typographyType="headingXXS"
            >
              {t("cancel")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              size="small"
              onClick={() => {
                setConfig(prev => ({ ...prev, theme: (prev.theme === 'dark' ? 'light' : 'dark') }))
                setModalTheme(false)
              }}
              typographyType="headingXXS"
            >
              {t("apply")}
            </Button>
          </div>
          <Typography type="paragraphS" color="title" >{t("dashboard.event.theme.modalFooter")}</Typography>
        </ModalContent>
      </Modal>

      {/*exclude modal*/}
      <Modal
        show={modalExclude}
        handleShow={setModalExclude}
        title={t("exclude")}
        description={t("dashboard.event.exclude.modalText")!}
      >
        <ModalContent>
          <div style={{ minWidth: '350px' }}>
            <Button
              variant="cancel"
              fullWidth
              size="small"
              onClick={() => setModalExclude(false)}
              typographyType="headingXXS"
            >
              {t("dashboard.event.exclude.cancel")}
            </Button>
            <Button
              size="small"
              variant="primary"
              fullWidth
              onClick={() => {
                setModalExclude(false)
              }}
              typographyType="headingXXS"
            >
              {t("dashboard.event.exclude.confirm")}
            </Button>
          </div>
          <Typography type="paragraphS" color="title" >{t("dashboard.event.exclude.modalFooter")}</Typography>
        </ModalContent>
      </Modal>

      {/*publish modal*/}
      <Modal
        show={modalPublish}
        handleShow={setModalPublish}
        title={t("dashboard.event.publish.modalTitle")}
        description={t("dashboard.event.publish.modalText")!}
      >
        <ModalContent>
          <div>
            <Button
              size="small"
              variant="cancel"
              fullWidth
              onClick={() => setModalPublish(false)}
              typographyType="headingXXS"
            >
              {t("dashboard.event.exclude.cancel")}
            </Button>
            <Button
              size="small"
              variant="primary"
              fullWidth
              onClick={() => onPublish()}
              typographyType="headingXXS"
              disabled={loading}
            >
              {t("dashboard.event.exclude.confirm")}
            </Button>
          </div>

        </ModalContent>
      </Modal>

      <EventialsHeader />

      <HeaderNav>
        <div>
          {!isMobile && (
            <>
              <Typography type="paragraphS" color="label">{t("manage")}</Typography>
              <ArrowRight color={colors.label} size={16} />
              <a onClick={() => window.location.href = (WL_URL + '/list-white-labels')}><Typography type="paragraphS" color="label">White Label</Typography></a>
              <ArrowRight color={colors.label} size={16} />
            </>
          )}
          <Typography type={isMobile ? "paragraphXXS" : "paragraphS"} color="title">{channel}</Typography>
        </div>

        <ButtonContainerDesktop >
          {/* <Button
            typographyType="paragraphS"
            variant="cancel"
            fullWidth
          >
            Preview
          </Button> */}
          <Button
            typographyType="headingXS"
            variant="primary"
            fullWidth
            onClick={() => setModalPublish(true)}
          >
            {t("publish")}
          </Button>
        </ButtonContainerDesktop>
      </HeaderNav>


      <Wrapper>
        <>
          <NavMenu>
            <NavMenuItem selected style={{ height: "40px" }}>
              <Typography color={"body"} type="headingXXS">{t("panel")}</Typography>
            </NavMenuItem>
          </NavMenu>
          <Divider />
        </>
        <Section>
          <Panel dataConfig={dataConfig} setDataConfig={setDataConfig} groups={groups} />
        </Section>
      </Wrapper>
      <ButtonContainerMobile >
        {/* <Button
          typographyType="paragraphS"
          variant="cancel"
          fullWidth
        >
          Preview
        </Button> */}
        <Button
          typographyType="headingXS"
          variant="primary"
          fullWidth
          onClick={() => setModalPublish(true)}
        >
          {t("publish")}
        </Button>
      </ButtonContainerMobile>
      <EvtsFooter />
    </Container>
  );
}